import { useEffect, useRef, useState } from "react";

const useInView = (threshold = 0.1) => {
  const ref = useRef(null);
  const [isVisible, setVisible] = useState(true);

  useEffect(() => {
    const node = ref.current;

    if (!node) {
      setVisible(true);
      return undefined;
    }

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setVisible(true);
      return undefined;
    }

    setVisible(false);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold,
        rootMargin: "0px 0px -12% 0px",
      }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [threshold]);

  return [ref, isVisible];
};

export default useInView;
